<template>
    <div class="no-app-wrap">
        <IconBase iconName="noAppIcon"
                  :width="noAppIcon.width"
                  :height="noAppIcon.height"
                  class="no-app-icon"></IconBase>
        <div class="no-app-indication">
            <div class="no-app-header font-3">
                ironSource Network Configuration
            </div>
            <span class="font-7">
                To go live, <span @click="$emit('openAppWizardModal')"
                                    class="add-app"> add your app </span>
                 from the store
            </span>
        </div>
    </div>
</template>

<script>
import IconBase from 'components/IconBase.vue';

export default {
    name: 'AppNotLive',
    components: { IconBase },
    data() {
        return {
            noAppIcon: {
                width: 117,
                height: 92
            }
        };
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/styleGuide";

.no-app-wrap {
    border-top: $border;
    text-align: center;
    margin-bottom: 30px;
}
.no-app-icon {
    margin: 32px 0 16px 0;
    object-fit: contain;
}

.no-app-indication {
    color: $light-700;
    margin: 16px 0 5px 0;
}

.add-app {
    color: $primary-500;
    cursor: pointer;
}

.no-app-header {
    margin-bottom: 5px;
    //font-family: NHaasGroteskDSPro-75Bd;
    //line-height: normal;
    //font-size: 15px;
}
</style>
